var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperatorsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,39c4.6,0,8.3-3.5,8.7-8H16.4C16.8,35.5,20.5,39,25,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,28.6c9,0,10.8,0,19.7,0c0.7,0,1.2-0.6,1.2-1.2l0,0c0-0.7-0.6-1.2-1.2-1.2h-0.5c-0.8-3.2-3.3-5.7-6.4-6.7 v2.2c0,0.6-0.5,1-1,1h-0.8v-4.4c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v4.4H23c-0.6,0-1-0.5-1-1v-2.1c-3.1,1-5.5,3.5-6.3,6.7h-0.6 c-0.7,0-1.2,0.6-1.2,1.2l0,0C13.9,28.1,14.5,28.6,15.1,28.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorsDefault);
export default __webpack_public_path__ + "static/media/operators-default.a1b498579c06de7edb532cd924791367.svg";
export { ForwardRef as ReactComponent };